import { render, staticRenderFns } from "./StepConfirm.vue?vue&type=template&id=22da486c&scoped=true"
import script from "./StepConfirm.vue?vue&type=script&lang=js"
export * from "./StepConfirm.vue?vue&type=script&lang=js"
import style0 from "./StepConfirm.vue?vue&type=style&index=0&id=22da486c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22da486c",
  null
  
)

export default component.exports